export enum InterviewDetailTab {
  Timeline = 'Timeline',
  AINotes = 'AI Notes',
  Analytics = 'Analytics',
  Clips = 'Clips',
  Assistant = 'Assistant',
}
